//import createPersistedState from "vuex-persistedstate";
//import Vue from 'vue';
//import Vuex from 'vuex';
import { createStore } from 'vuex';
import localforage from 'localforage';
import VuexPersist from 'vuex-persist';

import notes from './modules/notes';
import users from './modules/users';
import settings from './modules/settings';
import stocks from './modules/stocks';
import health from './modules/health';
import stockhistories from './modules/stockhistories';

import activities from './modules/activities';
import assemblies from './modules/assemblies';
import unknowns from './modules/unknowns';

import geoheatmaps from './modules/geoheatmaps';
import rankings from './modules/rankings';
import articles from './modules/articles';
import transactions from './modules/transactions';
import resources from './modules/resources';
import calender from './modules/calender';
import vacationChecklist from './modules/vacationChecklist';
import portfolio from "./modules/portfolio"
// ⚠️ Potentially non-serializable modules excluded by default:

//Am 12.10.25 umgestellt auf vuex-persist/localforage indexdb
//In DEV fuehlt es sich langsam an..intensiv testen ggfls wieder zurueck auf stand vom 11.10-25

import tracks from './modules/tracks';
import bilder from './modules/bilder';

//Vue.use(Vuex);

// Configure localForage to use IndexedDB (with fallbacks)
localforage.config({
  name: 'my-app-db',
  storeName: 'vuex-store',
  description: 'Vuex state persisted in IndexedDB via localForage',
  driver: [
    localforage.INDEXEDDB,
    localforage.WEBSQL,
    localforage.LOCALSTORAGE,
  ],
});

// ---------- JSON-safe sanitizer ----------
function replacer(_key, value) {
  // Drop functions/symbols
  if (typeof value === 'function' || typeof value === 'symbol') return undefined;

  // Handle Maps/Sets
  if (value instanceof Map) return { __type: 'Map', value: Array.from(value.entries()) };
  if (value instanceof Set) return { __type: 'Set', value: Array.from(value.values()) };

  // Handle Errors
  if (value instanceof Error) return { __type: 'Error', message: value.message, stack: value.stack || '' };

  // Basic check for DOM nodes / Proxies / circular oddities (best-effort)
  // DOM nodes usually have nodeType; skip them.
  if (value && typeof value === 'object' && value.nodeType === 1) return undefined;

  return value;
}

function reviver(_key, value) {
  if (value && value.__type === 'Map') return new Map(value.value);
  if (value && value.__type === 'Set') return new Set(value.value);
  if (value && value.__type === 'Error') {
    const e = new Error(value.message);
    e.stack = value.stack;
    return e;
  }
  return value;
}

// Make a deep JSON-safe copy (drops uncloneables)
function sanitize(obj) {
  try {
    return JSON.parse(JSON.stringify(obj, replacer));
  } catch {
    // As a last resort, drop it entirely if it still fails.
    return undefined;
  }
}

// ---------- VuexPersist with custom save/restore ----------
const vuexIndexedDB = new VuexPersist({
  key: 'app-store',
  storage: localforage,
  asyncStorage: true,

  // Persist only known-serializable slices first; add more later once stable.
  reducer: (state) => ({
    users: {
      authInitialized: false,
      authLoading: false,
      user: null,
    },
    settings: sanitize(state.settings),
    notes: sanitize(state.notes),
    stocks: sanitize(state.stocks),
    stockhistories: sanitize(state.stockhistories),
    activities: sanitize(state.activities),
    assemblies: sanitize(state.assemblies),
    unknowns: sanitize(state.unknowns),
    geoheatmaps: sanitize(state.geoheatmaps),
    rankings: sanitize(state.rankings),
    articles: sanitize(state.articles),
    transactions: sanitize(state.transactions),
    resources: sanitize(state.resources),
    calender: sanitize(state.calender),
    vacationChecklist: sanitize(state.vacationChecklist),
    // If/when safe, re-enable:
    bilder: sanitize(state.bilder),
    tracks: sanitize(state.tracks),
  }),

  // Store as a JSON string so IndexedDB never sees complex objects directly
  saveState: async (key, state, storage) => {
    const str = JSON.stringify(state, replacer);
    await storage.setItem(key, str);
  },

  // Restore from JSON string
  restoreState: async (key, storage) => {
    const str = await storage.getItem(key);
    if (!str || typeof str !== 'string') return {};
    try {
      return JSON.parse(str, reviver);
    } catch {
      // Corrupted? Start fresh.
      return {};
    }
  },
});

const store = createStore({
  modules: {
    notes,
    users,
    settings,
    stocks,
    stockhistories,
    activities,
    assemblies,
    unknowns,
    geoheatmaps,
    rankings,
    articles,
    transactions,
    resources,
    calender,
    vacationChecklist,
    bilder,
    tracks,
    health,
    portfolio,
  },
  plugins: [vuexIndexedDB.plugin],
});

export default store;
